import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { getPaymentLinksUrl } from 'FormsUI/lib/RouteGenerators';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentEmptyState = () => /*#__PURE__*/_jsx(View, {
  paddingBlockStart: "200",
  as: "div",
  children: /*#__PURE__*/_jsxs(Alert, {
    padding: "400",
    "data-test-id": "payment-empty-state-alert",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'editor.options.payment.noPaymentsLinkAlert.header'
    }),
    type: "info",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.options.payment.noPaymentsLinkAlert.message'
      })
    }), /*#__PURE__*/_jsx(Button, {
      size: "extra-small",
      use: "tertiary",
      external: true,
      href: getPaymentLinksUrl(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.options.payment.noPaymentsLinkAlert.link'
      })
    })]
  })
});
export default PaymentEmptyState;